import { RadioGroup, RadioOption } from "../../../component-library";
import { QueryType, YesNoRadioOptions } from "../../../models";
import { capitalizeFirst, displayDateAndTime } from "../../../helper-functions";
import { Col, Container, Row, Table } from "react-bootstrap";
import { RenderedFormProps } from "../RenderForm.tsx";
import { useTissueQuery, useUserBasicQuery } from "../../../queries";

const yesNoOptions = YesNoRadioOptions.map<RadioOption>((o) => ({ ...o, value: capitalizeFirst(o.value) }));

export const TissueOmarImport = ({ formState }: Readonly<RenderedFormProps>) => {
    const {
        detailQuery: { data: tissue },
    } = useTissueQuery({ queryType: QueryType.Detail, id: formState.formData?.tissueId });

    const {
        detailQuery: { data: user },
    } = useUserBasicQuery({ queryType: QueryType.Detail, id: tissue?.importedById });

    return (
        <Container className="p-4">
            <div className="text-center mb-4">
                <h1>Ocular Management Record - Import</h1>
            </div>
            <div className="mb-4">
                <Row>
                    <Col>Tissue Number: {tissue?.number}</Col>
                    <Col>Transfer Initiated by: {user?.name}</Col>
                    <Col>{displayDateAndTime(tissue?.importedOn)}</Col>
                </Row>
            </div>
            <Table bordered>
                <thead>
                    <tr>
                        <th className="col-6">Assessment of Incoming Tissue</th>
                        <th className="text-center">OD</th>
                        <th className="text-center">OS</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="col-6">
                            Tissue number on label is consistent with Donor information/Return information
                        </td>
                        <td className="text-center">
                            <RadioGroup
                                inline
                                options={yesNoOptions}
                                accessor="tissueNumberConsistentWithDonorInfoOD"
                            />
                        </td>
                        <td className="text-center">
                            <RadioGroup
                                inline
                                options={yesNoOptions}
                                accessor="tissueNumberConsistentWithDonorInfoOS"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className="col-6">Indication of wet-ice upon arrival</td>
                        <td className="text-center">
                            <RadioGroup inline options={yesNoOptions} accessor="indicationOfWetIceUponArrivalOD" />
                        </td>
                        <td className="text-center">
                            <RadioGroup inline options={yesNoOptions} accessor="indicationOfWetIceUponArrivalOS" />
                        </td>
                    </tr>
                    <tr>
                        <td className="col-6">Storage solution acceptable (if Optisol, color range acceptable)</td>
                        <td className="text-center">
                            <RadioGroup inline options={yesNoOptions} accessor="preservationMediumAcceptableOD" />
                        </td>
                        <td className="text-center">
                            <RadioGroup inline options={yesNoOptions} accessor="preservationMediumAcceptableOS" />
                        </td>
                    </tr>
                    <tr>
                        <td className="col-6">Shipping container: Secured and absent of leaks.</td>
                        <td className="text-center">
                            <RadioGroup
                                inline
                                options={yesNoOptions}
                                accessor="shippingContainerSecuredAndAbsentOfLeaksOD"
                            />
                        </td>
                        <td className="text-center">
                            <RadioGroup
                                inline
                                options={yesNoOptions}
                                accessor="shippingContainerSecuredAndAbsentOfLeaksOS"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className="col-6">
                            Tissue storage container: Absent of leaks and tamper-evident seals intact (if applicable)
                        </td>
                        <td className="text-center">
                            <RadioGroup
                                inline
                                options={yesNoOptions}
                                accessor="tissueStorageContainerAbsentOfLeaksAndTamperEvidentSealsIntactOD"
                            />
                        </td>
                        <td className="text-center">
                            <RadioGroup
                                inline
                                options={yesNoOptions}
                                accessor="tissueStorageContainerAbsentOfLeaksAndTamperEvidentSealsIntactOS"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className="col-6">Tissue was transported under Quarantine (if applicable)</td>
                        <td className="text-center">
                            <RadioGroup
                                inline
                                options={yesNoOptions}
                                accessor="tissueWasTransportedUnderQuarantineOD"
                            />
                        </td>
                        <td className="text-center">
                            <RadioGroup
                                inline
                                options={yesNoOptions}
                                accessor="tissueWasTransportedUnderQuarantineOS"
                            />
                        </td>
                    </tr>
                </tbody>
            </Table>
        </Container>
    );
};
